/** Переменные окружения и флаги. При `VITE_USE_MOCKS=true` приложение работает на MSW. */

function readBoolean(value: string | undefined, fallback: boolean): boolean {
  if (value === undefined || value === '') return fallback;
  return value === 'true' || value === '1';
}

export const env = {
  mode: import.meta.env.MODE,
  isDev: import.meta.env.DEV,
  isProd: import.meta.env.PROD,

  apiBaseUrl: import.meta.env.VITE_API_BASE_URL ?? '/api',
  placesApiBaseUrl: import.meta.env.VITE_PLACES_API_BASE_URL ?? '/api/places',
  twogisMapKey: import.meta.env.VITE_TWOGIS_MAP_KEY ?? '',

  useMocks: readBoolean(import.meta.env.VITE_USE_MOCKS, true),

  supportPhone: import.meta.env.VITE_SUPPORT_PHONE?.trim() ?? '',
  supportHours: import.meta.env.VITE_SUPPORT_HOURS ?? 'Пн–Пт 09:00–18:00 (Иркутск)',

  featureFlags: {
    documentPdfExport: readBoolean(import.meta.env.VITE_FF_DOCUMENT_PDF_EXPORT, true),
  },
} as const;
